import { buildRequests, sendRequests } from './fnk-restock-api.js';
import { productLists } from './fnk-restock-lists.js';

const dialog = document.getElementById('fnk-restock-dialog');
if (dialog && typeof dialog.showModal === 'function') {
  const form = dialog.querySelector('form');
  const fields = form.querySelector('fieldset');
  const select = form.elements.variant;
  const status = dialog.querySelector('[data-status]');
  const submit = form.querySelector('[type="submit"]');
  const productLink = dialog.querySelector('[data-product-link]');
  const messages = JSON.parse(dialog.querySelector('[data-messages]').textContent);
  let current;
  let opener;
  let loading;
  let submitting = false;
  let sequence = 0;

  function message(key, error = false) {
    status.textContent = messages[key] || messages.submit;
    status.dataset.error = String(error);
  }

  function close() {
    dialog.close();
  }

  dialog.querySelector('[data-close]').addEventListener('click', close);
  dialog.addEventListener('click', event => {
    if (event.target !== dialog) return;
    const bounds = dialog.getBoundingClientRect();
    if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) close();
  });
  dialog.addEventListener('close', () => {
    loading?.abort();
    sequence += 1;
    document.documentElement.classList.remove('fnk-restock-open');
    opener?.focus({ preventScroll: true });
    form.reset();
  });

  document.addEventListener('click', async event => {
    const trigger = event.target.closest?.('[data-fnk-restock]');
    if (!trigger || event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    event.stopPropagation();
    if (submitting) return;
    loading?.abort();
    loading = new AbortController();
    const attempt = ++sequence;
    opener = trigger;
    current = null;
    form.reset();
    form.hidden = false;
    fields.disabled = true;
    submit.disabled = true;
    select.replaceChildren();
    productLink.textContent = trigger.dataset.productTitle;
    productLink.href = trigger.dataset.productUrl;
    message('loading');
    if (!dialog.open) dialog.showModal();
    document.documentElement.classList.add('fnk-restock-open');
    try {
      const url = new URL(trigger.dataset.productUrl, location.origin);
      if (url.origin !== location.origin) throw new Error('load');
      url.pathname = `${url.pathname.replace(/\/$/, '')}.js`;
      url.search = '';
      const response = await fetch(url, { signal: AbortSignal.any([loading.signal, AbortSignal.timeout(15000)]), cache: 'no-store' });
      if (!response.ok) throw new Error('load');
      const product = await response.json();
      if (attempt !== sequence) return;
      if (String(product.id) !== trigger.dataset.productId) throw new Error('load');
      const variants = product.variants.filter(variant => !variant.available);
      if (!variants.length) {
        form.hidden = true;
        message('available');
        return;
      }
      current = { product, variants };
      if (variants.length > 1) select.add(new Option(messages.choose, ''));
      for (const variant of variants) select.add(new Option(variant.title === 'Default Title' ? messages.one_size : variant.title, String(variant.id)));
      const selected = trigger.dataset.variantId && url.pathname === `${location.pathname.replace(/\/$/, '')}.js`
        ? new URLSearchParams(location.search).get('variant') || trigger.dataset.variantId
        : trigger.dataset.variantId;
      if (selected && variants.some(variant => String(variant.id) === selected)) select.value = selected;
      productLink.textContent = product.title;
      fields.disabled = false;
      submit.disabled = false;
      status.textContent = '';
      form.elements.phone.focus({ preventScroll: true });
    } catch (error) {
      if (attempt !== sequence || error.name === 'AbortError') return;
      form.hidden = true;
      message('load', true);
    }
  }, true);

  form.addEventListener('submit', async event => {
    event.preventDefault();
    if (submitting || !current || !form.reportValidity()) return;
    const variant = current.variants.find(item => String(item.id) === select.value);
    if (!variant) { message('choose', true); return; }
    try {
      const requests = buildRequests({
        companyId: dialog.dataset.companyId,
        productId: current.product.id,
        variantId: variant.id,
        email: form.elements.email.value,
        phone: form.elements.phone.value,
        smsConsent: form.elements.sms_consent.checked,
        listId: productLists[current.product.id],
        fallbackLists: { EMAIL: dialog.dataset.emailList, SMS: dialog.dataset.smsList },
      });
      submitting = true;
      fields.disabled = true;
      submit.disabled = true;
      dialog.setAttribute('aria-busy', 'true');
      message('sending');
      await sendRequests(requests);
      form.hidden = true;
      form.reset();
      message('success');
      status.focus();
    } catch (error) {
      message(error.message, true);
    } finally {
      submitting = false;
      fields.disabled = false;
      submit.disabled = false;
      dialog.removeAttribute('aria-busy');
    }
  });
}
